module.exports = __webpack_public_path__ + "f7b366128ec45fbf4de2cdbe3998eec8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/sofas/sofa-sports.png
// module id = 996
// module chunks = 0